"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmptyChatHeader = exports.ChatHeader = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatHeader = function ChatHeader(_ref) {
    var minimizeMaximizeIconCssClassName = _ref.minimizeMaximizeIconCssClassName,
        onMinimizeButtonClick = _ref.onMinimizeButtonClick,
        onExpandButtonClick = _ref.onExpandButtonClick,
        dropDownOptionIonCss = _ref.dropDownOptionIonCss,
        hideChatBox = _ref.hideChatBox,
        stickyCSS = _ref.stickyCSS;
    return _react2.default.createElement(
        "div",
        { className: stickyCSS },
        _react2.default.createElement(
            "div",
            { className: "panel-heading row" },
            _react2.default.createElement(
                "div",
                { className: "col-xs-2 previous" },
                _react2.default.createElement(
                    "div",
                    { className: "btn-group" },
                    _react2.default.createElement(
                        "a",
                        { onClick: function onClick(e) {
                                e.preventDefault();
                                /* hideChatBox() */
                                onMinimizeButtonClick();
                            },
                            id: "button-back" },
                        _react2.default.createElement("span", { className: "glyphicon glyphicon-arrow-left" })
                    )
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "col-xs-5 chatdiv" },
                _react2.default.createElement(
                    "span",
                    null,
                    "Chat"
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "col-xs-4 controliconsdiv" },
                _react2.default.createElement(
                    "div",
                    { className: "controlicons" },
                    _react2.default.createElement(
                        "a",
                        { href: "#" },
                        _react2.default.createElement("span", {
                            id: "minim_chat_window",
                            className: minimizeMaximizeIconCssClassName,
                            onClick: function onClick(e) {
                                e.preventDefault();
                                onMinimizeButtonClick();
                            } })
                    ),
                    _react2.default.createElement(
                        "a",
                        { href: "#" },
                        _react2.default.createElement("span", {
                            id: "maxim_chat_window",
                            className: "fa fa-window-maximize icon_maxim",
                            onClick: function onClick(e) {
                                e.preventDefault();
                                onExpandButtonClick();
                            } })
                    )
                )
            )
        )
    );
};

var EmptyChatHeader = function EmptyChatHeader() {
    return _react2.default.createElement("div", { className: "panel-heading" });
};

exports.ChatHeader = ChatHeader;
exports.EmptyChatHeader = EmptyChatHeader;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatheader.js